(function() {
    'use strict';
    realmCommerceApp.config(config);

    /*@ngInject*/
    function config(toastrConfig) {
        angular.extend(toastrConfig, {
            positionClass: "container",
            allowHtml: true,
            closeButton: true,
            tapToDismiss: true,
            timeOut: 3000,
            debug: true,
            onTap: (toast) => {
                if (toast.scope.extraData && toast.scope.extraData.link) {
                    window.location.href = toast.scope.extraData.link;
                }
            }
        });
    }
})();


// WEBPACK FOOTER //
// ./static/js/app/config/toastr.config.js